import axios from 'axios';
import { call, fork, put } from 'redux-saga/effects';
import { all, takeLatest } from '@redux-saga/core/effects';

import { isClient, isDebug } from '../../configureStore';

import {
  GET_SCHEDULE_FAILURE,
  GET_SCHEDULE_REQUEST,
  GET_SCHEDULE_SUCCESS,
  COMMON_FAILURE,
  GET_SCHEDULE_RESERVATION_CONFIRM_SUCCESS,
  GET_SCHEDULE_RESERVATION_CONFIRM_FAILURE,
  GET_SCHEDULE_RESERVATION_CONFIRM_REQUEST,
  POST_SCHEDULE_RESERVATION_UPDATE_SUCCESS,
  POST_SCHEDULE_RESERVATION_UPDATE_FAILURE,
  POST_SCHEDULE_RESERVATION_UPDATE_REQUEST,
  POST_SCHEDULE_CANCEL_WAIT_REQUEST,
} from '../../actions';
import scheduleService from '../../services/scheduleService';

/** ********************************************************************
 * スケジュール取得API
 *********************************************************************** */
// const scheduleData = {
//   result: 0,
//   errorMessage: null,
//   programList: [
//     {
//       programId: '001',
//       programName: 'セルフエステ001',
//       selectFlag: 0,
//     },
//     {
//       programId: '002',
//       programName: 'ゴルフ練習打席002',
//       selectFlag: 0,
//     },
//     {
//       programId: '003',
//       programName: 'フィットネスジム003',
//       selectFlag: 1,
//     },
//     {
//       programId: '004',
//       programName: 'フィットネスジム004',
//       selectFlag: 0,
//     },
//     {
//       programId: '005',
//       programName: 'フィットネスジム005',
//       selectFlag: 0,
//     },
//     {
//       programId: '006',
//       programName: 'フィットネスジム006',
//       selectFlag: 0,
//     },
//     {
//       programId: '007',
//       programName: 'フィットネスジム007',
//       selectFlag: 0,
//     },
//   ],
//   scheduleList: [
//     {
//       infoDate: '20250703',
//       week: '金',
//       dayType: 'weekday',
//       contentsList: [
//         {
//           contentsId: '001',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 1,
//           cancelWaitNotice: 1,
//           frameList: [
//             { startTime: '1101', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1102', endTime: '1200', bookedCount: 4, totalCount: 4 },
//             { startTime: '1103', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1104', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1105', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1106', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1107', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1108', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1109', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1110', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1111', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1112', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1113', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1114', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1115', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1116', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1117', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1118', endTime: '1200', bookedCount: 1, totalCount: 4 },
//           ],
//         },
//         {
//           contentsId: '002',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 0,
//           cancelWaitNotice: 0,
//           frameList: [
//             { startTime: '1121', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1122', endTime: '1200', bookedCount: 4, totalCount: 4 },
//             { startTime: '1123', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1124', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1125', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1126', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1127', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1128', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1129', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1130', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1131', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1132', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1032', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1133', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1134', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1135', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1136', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1137', endTime: '1200', bookedCount: 1, totalCount: 4 },
//           ],
//         },
//         {
//           contentsId: '003',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 1,
//           frameList: [
//             { startTime: '1141', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1142', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1143', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1144', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1145', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1146', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1147', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1148', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1149', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1150', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1151', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1152', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1153', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1154', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1155', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1156', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1157', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1158', endTime: '1200', bookedCount: 1, totalCount: 4 },
//           ],
//         },
//       ],
//     },
//     {
//       infoDate: '20250704',
//       week: '土',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250705',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250706',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [
//         {
//           contentsId: '001',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 1,
//           cancelWaitNotice: 1,
//           frameList: [
//             { startTime: '1101', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1102', endTime: '1200', bookedCount: 4, totalCount: 4 },
//             { startTime: '1103', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1104', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1105', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1106', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1107', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1108', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1109', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1110', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1111', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1112', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1113', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1114', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1115', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1116', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1117', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1118', endTime: '1200', bookedCount: 1, totalCount: 4 },
//           ],
//         },
//         {
//           contentsId: '002',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 0,
//           cancelWaitNotice: 0,
//           frameList: [
//             { startTime: '1121', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1122', endTime: '1200', bookedCount: 4, totalCount: 4 },
//             { startTime: '1123', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1124', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1125', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1126', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1127', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1128', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1129', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1130', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1131', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1132', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1032', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1133', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1134', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1135', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1136', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1137', endTime: '1200', bookedCount: 1, totalCount: 4 },
//           ],
//         },
//         {
//           contentsId: '003',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 1,
//           frameList: [
//             { startTime: '1141', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1142', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1143', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1144', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1145', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1146', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1147', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1148', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1149', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1150', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1151', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1152', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1153', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1154', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1155', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1156', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1157', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1158', endTime: '1200', bookedCount: 1, totalCount: 4 },
//           ],
//         },
//       ],
//     },
//     {
//       infoDate: '20250707',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250708',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250709',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//   ],
// };

// const scheduleData = {
//   result: 0,
//   errorMessage: null,
//   programList: [
//     {
//       programId: '001',
//       programName: 'セルフエステ001',
//       selectFlag: 0,
//     },
//     {
//       programId: '002',
//       programName: 'ゴルフ練習打席002',
//       selectFlag: 0,
//     },
//     {
//       programId: '003',
//       programName: 'フィットネスジム003',
//       selectFlag: 1,
//     },
//     {
//       programId: '004',
//       programName: 'フィットネスジム004',
//       selectFlag: 0,
//     },
//     {
//       programId: '005',
//       programName: 'フィットネスジム005',
//       selectFlag: 0,
//     },
//     {
//       programId: '006',
//       programName: 'フィットネスジム006',
//       selectFlag: 0,
//     },
//     {
//       programId: '007',
//       programName: 'フィットネスジム007',
//       selectFlag: 0,
//     },
//   ],
//   scheduleList: [
//     {
//       infoDate: '20250703',
//       week: '金',
//       dayType: 'weekday',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250704',
//       week: '土',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250705',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250706',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250707',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250708',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250709',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//   ],
// };

// const resConfirmData = {
//   result: 0,
//   errorMessage: null,
//   contentsName: 'セルフエステ（男女兼用R）チケット予約',
//   annexFlag: 1,
//   contentsComment: 'aaaaaasa',
//   cancelTime: '7/5(土)12:00',
//   companionUpperLimit: 8,
//   scheduleReservationList: [
//     {
//       eqsId: 111,
//       eqsName: 'A',
//       annexFlag: 1,
//       remaining: 0,
//       nickName: 'ニックネームAA',
//       spaceName: 'スペースネームAA',
//       bookFlag: 0,
//       equipmentImage:
//         'https://ts1.tc.mm.bing.net/th/id/R-C.8bbf769b39bb26eefb9b6de51c23851d?rik=crTnc5i8A%2b8p7A&riu=http%3a%2f%2fpicview.iituku.com%2fcontentm%2fzhuanji%2fimg%2f202207%2f09%2fe7196ac159f7cf2b.jpg%2fnu&ehk=DYPLVpoNAXLj5qzwgR5vHf9DladFh%2b34s4UcuP3Kn6E%3d&risl=&pid=ImgRaw&r=0',
//     },
//     {
//       eqsId: 222,
//       eqsName: 'B',
//       annexFlag: 0,
//       remaining: 0,
//       nickName: 'ニックネームBB',
//       spaceName: 'スペースネームBB',
//       bookFlag: 0,
//       equipmentImage:
//         'https://ts1.tc.mm.bing.net/th/id/R-C.8bbf769b39bb26eefb9b6de51c23851d?rik=crTnc5i8A%2b8p7A&riu=http%3a%2f%2fpicview.iituku.com%2fcontentm%2fzhuanji%2fimg%2f202207%2f09%2fe7196ac159f7cf2b.jpg%2fnu&ehk=DYPLVpoNAXLj5qzwgR5vHf9DladFh%2b34s4UcuP3Kn6E%3d&risl=&pid=ImgRaw&r=0',
//     },
//     {
//       eqsId: 333,
//       eqsName: 'C',
//       annexFlag: 1,
//       remaining: 0,
//       nickName: 'ニックネームCC',
//       spaceName: 'スペースネームCC',
//       bookFlag: 1,
//       equipmentImage:
//         'https://ts1.tc.mm.bing.net/th/id/R-C.8bbf769b39bb26eefb9b6de51c23851d?rik=crTnc5i8A%2b8p7A&riu=http%3a%2f%2fpicview.iituku.com%2fcontentm%2fzhuanji%2fimg%2f202207%2f09%2fe7196ac159f7cf2b.jpg%2fnu&ehk=DYPLVpoNAXLj5qzwgR5vHf9DladFh%2b34s4UcuP3Kn6E%3d&risl=&pid=ImgRaw&r=0',
//     },
//     {
//       eqsId: 444,
//       eqsName: 'D',
//       annexFlag: 1,
//       remaining: 1,
//       nickName: '',
//       spaceName: 'スペースネームCC',
//       bookFlag: 0,
//       equipmentImage:
//         'https://ts1.tc.mm.bing.net/th/id/R-C.8bbf769b39bb26eefb9b6de51c23851d?rik=crTnc5i8A%2b8p7A&riu=http%3a%2f%2fpicview.iituku.com%2fcontentm%2fzhuanji%2fimg%2f202207%2f09%2fe7196ac159f7cf2b.jpg%2fnu&ehk=DYPLVpoNAXLj5qzwgR5vHf9DladFh%2b34s4UcuP3Kn6E%3d&risl=&pid=ImgRaw&r=0',
//     },
//   ],
// };

// const scheduleData = {
//   result: 0,
//   errorMessage: null,
//   programList: [
//     {
//       programId: '001',
//       programName: 'セルフエステ001',
//       selectFlag: 0,
//     },
//     {
//       programId: '002',
//       programName: 'ゴルフ練習打席002',
//       selectFlag: 1,
//     },
//     {
//       programId: '003',
//       programName: 'フィットネスジム003',
//       selectFlag: 0,
//     },
//     {
//       programId: '004',
//       programName: 'フィットネスジム004',
//       selectFlag: 0,
//     },
//     {
//       programId: '005',
//       programName: 'フィットネスジム005',
//       selectFlag: 0,
//     },
//     {
//       programId: '006',
//       programName: 'フィットネスジム006',
//       selectFlag: 0,
//     },
//     {
//       programId: '007',
//       programName: 'フィットネスジム007',
//       selectFlag: 0,
//     },
//   ],
//   scheduleList: [
//     {
//       infoDate: '20250703',
//       week: '土',
//       dayType: 'weekday',
//       contentsList: [
//         {
//           contentsId: '001',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 1,
//           frameList: [],
//         },
//       ],
//     },
//     {
//       infoDate: '20250704',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [],
//     },
//     {
//       infoDate: '20250705',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [
//         {
//           contentsId: '003',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 1,
//           frameList: [
//             { startTime: '1100', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1200', endTime: '1300', bookedCount: 2, totalCount: 4 },
//             { startTime: '1300', endTime: '1400', bookedCount: 3, totalCount: 4 },
//             { startTime: '1400', endTime: '1500', bookedCount: 4, totalCount: 4 },
//             { startTime: '1500', endTime: '1600', bookedCount: 5, totalCount: 5 },
//             { startTime: '1600', endTime: '1700', bookedCount: 4, totalCount: 6 },
//             { startTime: '1700', endTime: '1800', bookedCount: 2, totalCount: 3 },
//             { startTime: '1800', endTime: '1900', bookedCount: 3, totalCount: 4 },
//             { startTime: '1900', endTime: '2000', bookedCount: 4, totalCount: 5 },
//             { startTime: '2000', endTime: '2100', bookedCount: 2, totalCount: 3 },
//             { startTime: '2100', endTime: '2200', bookedCount: 2, totalCount: 3 },
//             { startTime: '2200', endTime: '2300', bookedCount: 4, totalCount: 5 },
//             { startTime: '2300', endTime: '0000', bookedCount: 3, totalCount: 3 },
//             { startTime: '0000', endTime: '0100', bookedCount: 4, totalCount: 5 },
//           ],
//         },
//         {
//           contentsId: '004',
//           contentsName: 'セルフエステ（女性専用20代限定キャンペーン）',
//           isAnnex: 1,
//           frameList: [
//             { startTime: '1100', endTime: '1200', bookedCount: 2, totalCount: 3 },
//             { startTime: '1200', endTime: '1300', bookedCount: 3, totalCount: 3 },
//             { startTime: '1300', endTime: '1400', bookedCount: 1, totalCount: 3 },
//             { startTime: '1400', endTime: '1500', bookedCount: 0, totalCount: 3 },
//             { startTime: '1500', endTime: '1600', bookedCount: 3, totalCount: 4 },
//             { startTime: '1600', endTime: '1700', bookedCount: 2, totalCount: 3 },
//           ],
//         },
//       ],
//     },
//     {
//       infoDate: '20250706',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [
//         {
//           contentsId: '003',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 1,
//           frameList: [
//             { startTime: '1100', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1200', endTime: '1300', bookedCount: 2, totalCount: 4 },
//             { startTime: '1300', endTime: '1400', bookedCount: 3, totalCount: 4 },
//             { startTime: '1400', endTime: '1500', bookedCount: 4, totalCount: 4 },
//             { startTime: '1500', endTime: '1600', bookedCount: 5, totalCount: 5 },
//             { startTime: '1600', endTime: '1700', bookedCount: 4, totalCount: 6 },
//             { startTime: '1700', endTime: '1800', bookedCount: 2, totalCount: 3 },
//             { startTime: '1800', endTime: '1900', bookedCount: 3, totalCount: 4 },
//             { startTime: '1900', endTime: '2000', bookedCount: 4, totalCount: 5 },
//             { startTime: '2000', endTime: '2100', bookedCount: 2, totalCount: 3 },
//             { startTime: '2100', endTime: '2200', bookedCount: 2, totalCount: 3 },
//             { startTime: '2200', endTime: '2300', bookedCount: 4, totalCount: 5 },
//             { startTime: '2300', endTime: '0000', bookedCount: 3, totalCount: 3 },
//             { startTime: '0000', endTime: '0100', bookedCount: 4, totalCount: 5 },
//           ],
//         },
//         {
//           contentsId: '004',
//           contentsName: 'セルフエステ（女性専用20代限定キャンペーン）',
//           isAnnex: 1,
//           frameList: [
//             { startTime: '1100', endTime: '1200', bookedCount: 2, totalCount: 3 },
//             { startTime: '1200', endTime: '1300', bookedCount: 3, totalCount: 3 },
//             { startTime: '1300', endTime: '1400', bookedCount: 1, totalCount: 3 },
//             { startTime: '1400', endTime: '1500', bookedCount: 0, totalCount: 3 },
//             { startTime: '1500', endTime: '1600', bookedCount: 3, totalCount: 4 },
//             { startTime: '1600', endTime: '1700', bookedCount: 2, totalCount: 3 },
//           ],
//         },
//       ],
//     },
//     {
//       infoDate: '20250707',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [
//         {
//           contentsId: '003',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 1,
//           frameList: [
//             { startTime: '1100', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1200', endTime: '1300', bookedCount: 2, totalCount: 4 },
//             { startTime: '1300', endTime: '1400', bookedCount: 3, totalCount: 4 },
//             { startTime: '1400', endTime: '1500', bookedCount: 4, totalCount: 4 },
//             { startTime: '1500', endTime: '1600', bookedCount: 5, totalCount: 5 },
//             { startTime: '1600', endTime: '1700', bookedCount: 4, totalCount: 6 },
//             { startTime: '1700', endTime: '1800', bookedCount: 2, totalCount: 3 },
//             { startTime: '1800', endTime: '1900', bookedCount: 3, totalCount: 4 },
//             { startTime: '1900', endTime: '2000', bookedCount: 4, totalCount: 5 },
//             { startTime: '2000', endTime: '2100', bookedCount: 2, totalCount: 3 },
//             { startTime: '2100', endTime: '2200', bookedCount: 2, totalCount: 3 },
//             { startTime: '2200', endTime: '2300', bookedCount: 4, totalCount: 5 },
//             { startTime: '2300', endTime: '0000', bookedCount: 3, totalCount: 3 },
//             { startTime: '0000', endTime: '0100', bookedCount: 4, totalCount: 5 },
//           ],
//         },
//         {
//           contentsId: '004',
//           contentsName: 'セルフエステ（女性専用20代限定キャンペーン）',
//           isAnnex: 1,
//           frameList: [
//             { startTime: '1100', endTime: '1200', bookedCount: 2, totalCount: 3 },
//             { startTime: '1200', endTime: '1300', bookedCount: 3, totalCount: 3 },
//             { startTime: '1300', endTime: '1400', bookedCount: 1, totalCount: 3 },
//             { startTime: '1400', endTime: '1500', bookedCount: 0, totalCount: 3 },
//             { startTime: '1500', endTime: '1600', bookedCount: 3, totalCount: 4 },
//             { startTime: '1600', endTime: '1700', bookedCount: 2, totalCount: 3 },
//           ],
//         },
//       ],
//     },
//     {
//       infoDate: '20250708',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [
//         {
//           contentsId: '003',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 1,
//           frameList: [
//             { startTime: '1100', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1200', endTime: '1300', bookedCount: 2, totalCount: 4 },
//             { startTime: '1300', endTime: '1400', bookedCount: 3, totalCount: 4 },
//             { startTime: '1400', endTime: '1500', bookedCount: 4, totalCount: 4 },
//             { startTime: '1500', endTime: '1600', bookedCount: 5, totalCount: 5 },
//             { startTime: '1600', endTime: '1700', bookedCount: 4, totalCount: 6 },
//             { startTime: '1700', endTime: '1800', bookedCount: 2, totalCount: 3 },
//             { startTime: '1800', endTime: '1900', bookedCount: 3, totalCount: 4 },
//             { startTime: '1900', endTime: '2000', bookedCount: 4, totalCount: 5 },
//             { startTime: '2000', endTime: '2100', bookedCount: 2, totalCount: 3 },
//             { startTime: '2100', endTime: '2200', bookedCount: 2, totalCount: 3 },
//             { startTime: '2200', endTime: '2300', bookedCount: 4, totalCount: 5 },
//             { startTime: '2300', endTime: '0000', bookedCount: 3, totalCount: 3 },
//             { startTime: '0000', endTime: '0100', bookedCount: 4, totalCount: 5 },
//           ],
//         },
//         {
//           contentsId: '004',
//           contentsName: 'セルフエステ（女性専用20代限定キャンペーン）',
//           isAnnex: 1,
//           frameList: [
//             { startTime: '1100', endTime: '1200', bookedCount: 2, totalCount: 3 },
//             { startTime: '1200', endTime: '1300', bookedCount: 3, totalCount: 3 },
//             { startTime: '1300', endTime: '1400', bookedCount: 1, totalCount: 3 },
//             { startTime: '1400', endTime: '1500', bookedCount: 0, totalCount: 3 },
//             { startTime: '1500', endTime: '1600', bookedCount: 3, totalCount: 4 },
//             { startTime: '1600', endTime: '1700', bookedCount: 2, totalCount: 3 },
//           ],
//         },
//       ],
//     },
//     {
//       infoDate: '20250709',
//       week: '日',
//       dayType: 'weekday-gray',
//       contentsList: [
//         {
//           contentsId: '003',
//           contentsName: 'セルフエステ（男女兼用R）チケット予約',
//           isAnnex: 1,
//           frameList: [
//             { startTime: '1100', endTime: '1200', bookedCount: 1, totalCount: 4 },
//             { startTime: '1200', endTime: '1300', bookedCount: 2, totalCount: 4 },
//             { startTime: '1300', endTime: '1400', bookedCount: 3, totalCount: 4 },
//             { startTime: '1400', endTime: '1500', bookedCount: 4, totalCount: 4 },
//             { startTime: '1500', endTime: '1600', bookedCount: 5, totalCount: 5 },
//             { startTime: '1600', endTime: '1700', bookedCount: 4, totalCount: 6 },
//             { startTime: '1700', endTime: '1800', bookedCount: 2, totalCount: 3 },
//             { startTime: '1800', endTime: '1900', bookedCount: 3, totalCount: 4 },
//             { startTime: '1900', endTime: '2000', bookedCount: 4, totalCount: 5 },
//             { startTime: '2000', endTime: '2100', bookedCount: 2, totalCount: 3 },
//             { startTime: '2100', endTime: '2200', bookedCount: 2, totalCount: 3 },
//             { startTime: '2200', endTime: '2300', bookedCount: 4, totalCount: 5 },
//             { startTime: '2300', endTime: '0000', bookedCount: 3, totalCount: 3 },
//             { startTime: '0000', endTime: '0100', bookedCount: 4, totalCount: 5 },
//           ],
//         },
//         {
//           contentsId: '004',
//           contentsName: 'セルフエステ（女性専用20代限定キャンペーン）',
//           isAnnex: 1,
//           frameList: [
//             { startTime: '1100', endTime: '1200', bookedCount: 2, totalCount: 3 },
//             { startTime: '1200', endTime: '1300', bookedCount: 3, totalCount: 3 },
//             { startTime: '1300', endTime: '1400', bookedCount: 1, totalCount: 3 },
//             { startTime: '1400', endTime: '1500', bookedCount: 0, totalCount: 3 },
//             { startTime: '1500', endTime: '1600', bookedCount: 3, totalCount: 4 },
//             { startTime: '1600', endTime: '1700', bookedCount: 2, totalCount: 3 },
//           ],
//         },
//       ],
//     },
//   ],
// };

// const scheduleDetailDemoTata = {
//   result: 0,
//   errorMessage: null,
//   contentsId: '001',
//   contentsName: 'セルフエステ（女性専用20代限定キャンペーン）',
//   infoDate: '20250916',
//   frameCount: 2,
//   startTime: '1315',
//   endTime: '1700',
//   frameList: [
//     { startTime: '1315', endTime: '1400', bookedFlag: 1 },
//     { startTime: '1645', endTime: '1700', bookedFlag: 0 },
//   ],
// };

function* getSchedule(action: any): Generator<any> {
  try {
    // console.log(action);
    const res: any = yield call(scheduleService(action).getSchedule);
    // console.log('getSchedule response:', res.data);
    // const res: any = scheduleData;
    yield put({
      type: GET_SCHEDULE_SUCCESS,
      data: res.data,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: GET_SCHEDULE_FAILURE,
        error,
      });
      yield put({
        type: COMMON_FAILURE,
        response: error.response,
      });
      if (isClient && isDebug) {
        action.history.push('/systemError');
      } else {
        action.history.push('/systemError');
      }
    }
  }
}

function* getReserveConfirm(action: any): Generator<any> {
  try {
    const res: any = yield call(scheduleService(action).getReserveConfirmData);
    // const res: any = resConfirmData;
    yield put({
      type: GET_SCHEDULE_RESERVATION_CONFIRM_SUCCESS,
      data: res.data,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: GET_SCHEDULE_RESERVATION_CONFIRM_FAILURE,
        error,
      });
      yield put({
        type: COMMON_FAILURE,
        response: error.response,
      });
      if (isClient && isDebug) {
        action.history.push('/systemError');
      } else {
        action.history.push('/systemError');
      }
    }
  }
}

function* postScheduleReservation(action: any): Generator<unknown> {
  try {
    const res: any = yield call(scheduleService(action).postScheduleReservation);
    // const res = {
    //   status: 200,
    //   data: {
    //     result: 0,
    //     errorMessage: null,
    //   },
    // };
    if (res && res.status === 200) {
      yield put({
        type: POST_SCHEDULE_RESERVATION_UPDATE_SUCCESS,
        data: res.data,
      });
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: POST_SCHEDULE_RESERVATION_UPDATE_FAILURE,
      });
      yield put({
        type: COMMON_FAILURE,
        response: error.response,
      });
      if (isClient && isDebug) {
        action.history.push('/systemError');
      } else {
        action.history.push('/systemError');
      }
    }
  }
}

function* postScheduleCancelWait(action: any): Generator<unknown> {
  try {
    const res: any = yield call(scheduleService(action).postScheduleCancelWait);
    // const res = {
    //   status: 200,
    //   data: {
    //     result: 0,
    //     errorMessage: null,
    //   },
    // };
    if (res && res.status === 200) {
      yield put({
        type: POST_SCHEDULE_RESERVATION_UPDATE_SUCCESS,
        data: res.data,
      });
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: POST_SCHEDULE_RESERVATION_UPDATE_FAILURE,
      });
      yield put({
        type: COMMON_FAILURE,
        response: error.response,
      });
      if (isClient && isDebug) {
        action.history.push('/systemError');
      } else {
        action.history.push('/systemError');
      }
    }
  }
}

function* watchGetSchedule() {
  yield takeLatest(GET_SCHEDULE_REQUEST, getSchedule);
}

function* watchGetReserveConfirm() {
  yield takeLatest(GET_SCHEDULE_RESERVATION_CONFIRM_REQUEST, getReserveConfirm);
}

function* watchPostScheduleReservation() {
  yield takeLatest(POST_SCHEDULE_RESERVATION_UPDATE_REQUEST, postScheduleReservation);
}

function* watchPostScheduleCancelWait() {
  yield takeLatest(POST_SCHEDULE_CANCEL_WAIT_REQUEST, postScheduleCancelWait);
}

export default function* ScheduleSaga() {
  yield all([
    fork(watchGetSchedule),
    fork(watchGetReserveConfirm),
    fork(watchPostScheduleReservation),
    fork(watchPostScheduleCancelWait),
  ]);
}
